/**
 * FunnelKit `[fk_cart_menu]` shortcode rendruje się server-side z cookies
 * `fkcart_cart_total` / `fkcart_cart_qty`, które są ustawiane przez FK JS
 * po pierwszym AJAX'ie. Te cookies bywają stale (poprzednia sesja, dwie karty,
 * dodanie do koszyka w innej zakładce) — header pokazuje zły total/qty
 * dopóki user nie kliknie side cart, który wymusza świeży `fkcart_get_slide_cart`.
 *
 * Ten moduł:
 *  1. Kasuje stale cookies + sessionStorage fragmentów.
 *  2. Triggeruje `fkcart_update_side_cart` — ten sam AJAX co otwarcie side cart.
 *  3. Odpala się na `load` (nie DOMContentLoaded) żeby cart.min.js zdążył się
 *     załadować i zarejestrować listenery.
 */

function killCookie(name) {
    const paths = ['/', '/' + window.location.pathname.split('/')[1]];
    for (const p of paths) {
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${p}`;
        document.cookie = `${name}=; expires=Thu, 01 Jan 1970 00:00:00 GMT; path=${p}; domain=${window.location.hostname}`;
    }
}

function getCookie(name) {
    const m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : null;
}

/**
 * Stale = cookie pokazuje koszyk, ale WC body class mówi że jest pusty
 * (`.woocommerce-cart-is-empty` / brak fragmentu z item count).
 * BezBez tego warunku — kasujemy state przy każdym page load i fkcart traci
 * swoje listenery na `added_to_cart`, więc side cart nie otwiera się po dodaniu.
 */
function isCartStale() {
    const cookieQty = parseInt(getCookie('fkcart_cart_qty') || '0', 10);
    if (cookieQty <= 0) return false;

    // Body ma klasę `woocommerce-cart-is-empty` gdy WC widzi pusty koszyk.
    if (document.body.classList.contains('woocommerce-cart-is-empty')) return true;

    return false;
}

function refresh() {
    if (!window.jQuery || !document.getElementById('fkcart-modal')) return;
    if (!isCartStale()) return;

    killCookie('fkcart_cart_total');
    killCookie('fkcart_cart_qty');

    try {
        if (window.wc_cart_fragments_params) {
            const p = window.wc_cart_fragments_params;
            if (p.fragment_name) sessionStorage.removeItem(p.fragment_name);
            if (p.cart_hash_key) sessionStorage.removeItem(p.cart_hash_key);
        }
        if (window.fkcart_app_data) {
            const p = window.fkcart_app_data;
            if (p.fragment_name) sessionStorage.removeItem(p.fragment_name);
            if (p.cart_hash_key) sessionStorage.removeItem(p.cart_hash_key);
        }
    } catch (_) {
        /* sessionStorage niedostępny w privacy mode */
    }

    window.jQuery(document.body).trigger('fkcart_update_side_cart', [false]);
}

export function initFkcartRefresh() {
    if (document.readyState === 'complete') {
        setTimeout(refresh, 200);
    } else {
        window.addEventListener('load', () => setTimeout(refresh, 200));
    }
}
